import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { handleChangeDataCouriersPage } from '../../../../redux/actions/pages/couriers';
import { handleSetOpenCustomSnackbar } from '../../../../redux/actions/snackbar';
import { handleSetBackdropLoading } from '../../../../redux/actions/loaders';
import { handleChangeDataAddCourierPage } from '../../../../redux/actions/pages/couriers/add';
import { API_COURIERS, API_ASIGN_COURIER, API_DELETE_COURIER } from '../../../../apis';
import apiRequest from '../../../../utils/apiRequest'; 
import { Row, Col } from 'react-bootstrap';
import { motion } from "framer-motion";
import { DatePicker } from "react-advance-jalaali-datepicker";
import { handleChangeDataModalAddToStock } from '../../../../redux/actions/partials/modals/modalAddToStock';
import { handleChangeDataModalEditTransFactorNum } from '../../../../redux/actions/partials/modals/modalEditTransFactorNum'
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Select from 'react-select';
import Swal from 'sweetalert2';
import KoochiLogo from '../../../../styles/images/koochi-logo.png';


const Couriers = () => {

	const dispatch = useDispatch();
    const navigate = useNavigate();


	const { token } = useSelector(state => state.login);
    const { myProducts, allProducts, inputProductName, categories, inputCategory} = useSelector(state => state.products);
    const { couriers, pageType, consignmentCode } = useSelector(state => state.couriers);
    const { isBackdropLoading } = useSelector(state => state.allLoaders);
    

    useEffect(() => {
        // dispatch(handleChangeDataProductsPage('inputProductName', ''));
        // dispatch(handleChangeDataProductsPage('inputCategory', ''));
        apiCouriers();
        // eslint-disable-next-line
    }, []);


    const [isSearchVisible, setIsSearchVisible] = useState(false);

    const [isHeadingElementsVisible, setIsHeadingElementsVisible] = useState(false);

    const [time, setTime] = useState(null);


    const apiCouriers = (event) => {
        if(event !== undefined)
            event.preventDefault();

        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: API_COURIERS,
                method: 'get',
                token: token,
                successMessage: null,
                onSuccess: (res) => {
                    dispatch(handleChangeDataCouriersPage('couriers', res.couriers));
                },
            });
        }

    };



    const showModalAddToStock = (key) => {
        dispatch(handleChangeDataModalAddToStock('isOpen', true));
        dispatch(handleChangeDataModalAddToStock('product', allProducts[key]));
    };


    const handleClickSearchBtn = () => {
        setIsSearchVisible(! isSearchVisible);
        setIsHeadingElementsVisible(false);
    };

    const handleChangeInputs = (event) => {
        const {name, value} = event.target;
        // dispatch(handleChangeDataProductsPage(name, value));
    };

    const handleChangeCatSelected = (option) => {
        // dispatch(handleChangeDataProductsPage('inputCategory', (option ? option.value : '')));
    };

    const selectCourier = (courier) => {
        if(! isBackdropLoading) {
            apiRequest({
                dispatch,
                endpoint: API_ASIGN_COURIER,
                method: 'post',
                data: {consignmentCode, selectedCourier: courier.id},
                token: token,
                successMessage: 'اختصاص پیک با موفقیت انجام شد',
                onSuccess: (res) => {
                    navigate(-1);
                },
            });
        }

        
    };


    const handleClickEditBtn = (courier) => {
        dispatch(handleChangeDataAddCourierPage('fname', courier.fname));
        dispatch(handleChangeDataAddCourierPage('lname', courier.lname));
        dispatch(handleChangeDataAddCourierPage('mobile', courier.mobile));
        dispatch(handleChangeDataAddCourierPage('national_code', courier.nationalCode));
        dispatch(handleChangeDataAddCourierPage('phone', courier.phone));
        dispatch(handleChangeDataAddCourierPage('vehicle_model', courier.vehicleModel));
        dispatch(handleChangeDataAddCourierPage('plate', courier.plate));
        dispatch(handleChangeDataAddCourierPage('status', courier.status));
    };

    const showModalDeleteWarning = (courier) => {
        if(! isBackdropLoading) {
            const buttonsOkCancel = Swal.mixin({
                customClass: {
                    confirmButton: 'btn  btn-outline-primary width-80 mr-2',
                    cancelButton: 'btn grey btn-outline-secondary width-80',
                },
                buttonsStyling: false
            });

            buttonsOkCancel.fire({
                text: "آیا اط حذف پیک اطمینان دارید؟",
                imageUrl: KoochiLogo,
                imageHeight: 60,
                imageAlt: 'کوچی',
                confirmButtonText: "بله",
                showCancelButton: true,
                cancelButtonText: 'انصراف',
            }).then((result) => {
                if (result.isConfirmed) {
                    apiRequest({
                        dispatch,
                        endpoint: API_DELETE_COURIER,
                        method: 'post',
                        data: {courier: courier.id},
                        token: token,
                        successMessage: 'پیک مورد نظر با موفقیت حذف شد',
                        onSuccess: (res) => {
                            apiCouriers();
                        },
                    });
                }
            }); 
        }
            
    };


    return (
		<div className="app-content content container-fluid">
            <div className="content-wrapper">
                <div className="content-header row">
                </div>
                <div className="content-body">




                    <Row>
                        <Col className="col-xs-12">
                            <div className="card" style={{minHeight: 'unset !important'}} >
                                <div className="card-header">
                                    <h4 className="card-title">پیک های من</h4>
                                    <a className="heading-elements-toggle" onClick={() => setIsHeadingElementsVisible(! isHeadingElementsVisible)}><i className="icon-ellipsis font-medium-3"></i></a>
                                    <div className={`heading-elements ${isHeadingElementsVisible ? 'visible' : ''}`}>
                                        <ul className="list-inline mb-0">
                                            <li><a data-action="collapse"><i className="icon-minus4"></i></a></li>
                                            <li><Link to={`add`} title="ثبت پیک جدید"><i class="icon-plus-square-o"></i></Link></li>
                                            <li><a onClick={() => apiCouriers()} title="رفرش"><i className="icon-reload" style={{color: '#0100fe'}}></i></a></li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="card-body collapse in">

                                    {isSearchVisible && (
                                    <motion.div 
                                        className="card-block" id="div-search"
                                        initial={{ opacity: 0, height: 0, scale: 0.8 }}
                                        animate={{ opacity: 1, height: "auto", scale: 1 }}
                                        exit={{ opacity: 0, height: 0, scale: 0.8 }}
                                        transition={{ duration: 0.5, ease: "easeOut" }} >
                                        <form onSubmit={apiCouriers} >
                                            <div className="form-body" style={{overflow: 'unset !important'}} >
                                                <Row className="row">
                                                    <div className="form-group col-md-3">
                                                        <label class="c-label">بخشی از نام محصول</label>
                                                        <input name="inputProductName" value={inputProductName} onChange={handleChangeInputs} type="text" className="form-control" />
                                                    </div>
                                                    <div className="form-group col-md-3">
                                                        <label class="c-label">دسته بندی</label>
                                                        <Select options={categories} name="inputCategory"  onChange={handleChangeCatSelected} placeholder="انتخاب کنید" />
                                                    </div>
                                                </Row>
                                                <Row className="row">
                                                    <div className="form-group col-md-3">
                                                        <button type="submit" id="btn-search" className="btn btn-success w-100" name="search_btn" value="search" >
                                                            <i className="icon-search"></i> جستجو 
                                                        </button>
                                                    </div>
                                                </Row>
                                            </div>
                                        </form>
                                    </motion.div>
                                    )}

                                    <div className="table-responsive">
                                        <table className="table mb-0 table-bordered table-striped">
                                            <thead>
                                                <tr>
                                                    <th style={{width: '1%'}} >#</th>
                                                    <th>نام </th>
                                                    <th>موبایل/ثابت</th>
                                                    <th>کدملی</th>
                                                    <th>خودرو</th>
                                                    <th>پلاک</th>
                                                    <th>وضعیت</th>
                                                    <th>عملیات</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    couriers.map((courier, key) => {
                                                        return(
                                                            <tr key={`tr-content-${key}`}>
                                                                <td> {key + 1} </td>
                                                                <td > {courier.fname} {courier.lname} </td>
                                                                <td > {courier.mobile} <br />{courier.phone} </td>
                                                                <td > {courier.nationalCode} </td>
                                                                <td > {courier.vehicleModel} </td>
                                                                <td > {courier.plate} </td>
                                                                <td > {courier.status} </td>
                                                                <td>
                                                                    { pageType === "selectForOrder" &&
                                                                        <span
                                                                            onClick={() => selectCourier(courier)}
                                                                            className={`tag tag-primary tag-status`}
                                                                            style={{ cursor:"pointer" }}
                                                                        >
                                                                            انتخاب
                                                                        </span>
                                                                    }

                                                                    { pageType === "couriers" &&
                                                                        <>
                                                                            <Link to={`edit/${courier.id}`} onClick={() => handleClickEditBtn(courier)} title="ویرایش" style={{marginRight: "15px"}} >
                                                                                <i class="icon-edit2"></i>
                                                                            </Link>
                                                                            <Link onClick={() => showModalDeleteWarning(courier)} class="delete-btn"  title="حذف" >
                                                                                <i class="icon-trash-o"></i>
                                                                            </Link>
                                                                        </>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav aria-label="Page navigation" className="text-xs-center" style={{marginTop: '3%'}} >

                                    </nav>
                                </div>
                            </div>
                        </Col>
                    </Row>





                </div>
            </div>
        </div>
    );
}

export default Couriers;